import axios from "axios";
import getHeaders from "./requestHeaders";

function sendRequest(method, url, headers = {}, data = {}, auth=true, queryParams = {}, contentType = 'application/json') {
    var messageReceive = [];

    if (!queryParams.language) {
        queryParams.language = localStorage.getItem('language');
    }

    var configAxios = {
        method: method,
        url: url,
        headers: getHeaders(headers, auth, contentType),
        data: data,
        params: queryParams
    }

    return axios(configAxios)
        .then(function (response) {
            messageReceive = ["success", response];
        }).catch(function (error) {
            messageReceive = ["error", error];
        }).then(function () {
            // var errors = [500, 404, 403];
            // if(messageReceive[0] === "error" && errors.includes(messageReceive[1].response.status)) {
            //     window.location = "/error/"+messageReceive[1].response.status;
            // }
            return messageReceive;
        });
}

export default sendRequest;